import { useState, useMemo, useEffect, forwardRef } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  ListSubheader,
  TextField,
  InputAdornment,
  InputLabel,
  Checkbox,
  ListItemText,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getAllCustomers } from 'src/services/projectService';

interface ClientDropdownProps {
  title: string;
  value: string; 
  onChange: (value: string) => void;
  width?: string;
  disabled?: boolean;
}

const ClientDropdown = forwardRef((props: ClientDropdownProps, _ref) => {
  const [searchText, setSearchText] = useState<string>('');
  const [list, setList] = useState([]);
  const [selectedValues, setSelectedValues] = useState<string[]>(props.value ? props.value.split(',') : []);

  const containsText = (text: string, searchText: string) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  const fetchLists = () => {
    getAllCustomers().then((res) => {
      setList(res.data);
    });
  };

  const filteredLists = useMemo(() => {
    return list?.filter((option) => containsText(option?.name, searchText));
  }, [searchText, list]);

  const handleSelectChange = (event: any) => {
    const values = event.target.value;
    setSelectedValues(values);
    props.onChange(values.join(',')); 
  };

  
  useEffect(() => {
    if (props.value === null) {
      setSelectedValues([]); 
    } else {
      setSelectedValues(props.value.split(',')); 
    }
  }, [props.value]);

  return (
    <FormControl fullWidth disabled={props?.disabled ? props?.disabled : false}>
      <InputLabel
        style={{
          fontSize: '12px',
        }}
      >
        {props?.title ? props?.title : ''}
      </InputLabel>
      <Select
        id="filter-client"
        sx={{ mt: 1 }}
        style={{
          width: props?.width ? props?.width : '100%',
          fontSize: '12px',
          height: '2rem',
        }}
        size="small"
        multiple
        value={selectedValues} 
        onChange={handleSelectChange}
        onOpen={() => fetchLists()}
        onClose={() => setSearchText('')}
        renderValue={(selected) =>
          selected
            .map((id) => {
              const selectedItem = list.find((item) => item.id === id);
              return selectedItem?.name;
            })
            .join(', ') 
        }
      >
        <ListSubheader>
          <TextField
            id="search-project"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          />
        </ListSubheader>
        {filteredLists?.length > 0 &&
          filteredLists.map((item, i) => (
            <MenuItem key={i} value={item.id}>
              <Checkbox checked={selectedValues.includes(item.id)} />
              <ListItemText primary={item.name} />
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
});

export default ClientDropdown;